import { css } from "@emotion/css";
import { borderRadius, fontSize, lineHeight, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import React from "react";
import ExternalLink from "../Navigation/ExternalLink";
import type { NextStep } from "./nextStepsData";
type NextStepsCardProps = NextStep;
export function NextStepsCard({ title, description, linkLabel, linkHref }: NextStepsCardProps) {
    return (<div className={styles.cardBase}>
            <div>
                <span className={styles.title}>{title}</span>
                <p className={styles.description}>{description}</p>
            </div>
            <ExternalLink href={linkHref} trackAnalytics linkLocation="FirstDeploymentBanner">
                {linkLabel}
            </ExternalLink>
        </div>);
}
export const styles = {
    cardBase: css({
        padding: space[16],
        borderRadius: borderRadius.small,
        boxShadow: themeTokens.shadow.small,
        backgroundColor: themeTokens.color.card.background.primary.default,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        flex: 1,
        fontSize: fontSize.medium,
    }),
    description: css({
        marginTop: space[4],
    }),
    title: css({
        font: text.heading.small,
        fontSize: fontSize.medium,
        lineHeight: lineHeight.xSmall,
    }),
};
